import { NavLink } from 'react-router-dom';
import styles from './mobileNavbar.module.css';
import { HiChevronDown } from 'react-icons/hi';
import { useContext, useState } from 'react';
import AppContext from '../../contexts/Appcontext';

export default function MobileNavbar() {

  const { productsCategory } = useContext(AppContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  function activeLinkStyler(isActive) {
    return isActive ? { color: 'var(--darkOrange)' } : {}
  }

  function toggleSubmenu() {
    if (isOpen) {
      setIsAnimating(true);
      setIsOpen(false);
      setTimeout(() => { setIsAnimating(false) }, 600);
    } else {
      setIsOpen(true);
    }
  }

  function calculateHeight() {
    if (productsCategory.length) {
      const subMenusCount = productsCategory.length;
      const gapsCount = subMenusCount - 1;
      const height = (subMenusCount * 50) + (gapsCount * 4);
      return height;
    }
  }

  return (
    <nav className={styles.navbar}>
      <ul className='d-flex flex-column gap-1'>
        <li className={styles.menuItem1}><NavLink to='/' style={({ isActive }) => activeLinkStyler(isActive)}>خانه</NavLink></li>
        <li className={styles.menuItem1}>
          <a href='#' onClick={toggleSubmenu}>محصولات<HiChevronDown className='me-1' /></a>
          <ul className={styles.menuContainer2} style={isOpen ? { height: `${calculateHeight()}px` } : isAnimating ? { height: '0' } : {}}>
            {productsCategory.map(category =>
              <li key={category.id}>
                <NavLink to={`/products/${category.slug}`} style={({ isActive }) => activeLinkStyler(isActive)}>
                  {category.name}
                </NavLink>
              </li>
            )}
          </ul>
        </li>
        <li className={styles.menuItem1}><NavLink to='/protocols' style={({ isActive }) => activeLinkStyler(isActive)}>پروتکل</NavLink></li>
        <li className={styles.menuItem1}><NavLink to='/contactUs' style={({ isActive }) => activeLinkStyler(isActive)}>تماس</NavLink></li>
        <li className={styles.menuItem1}><NavLink to='/aboutUs' style={({ isActive }) => activeLinkStyler(isActive)}>درباره ما</NavLink></li>
      </ul>
    </nav>
  )
}
